import React from 'react';
import PercentageWizardTable from './percentageWizardTable';
import FormResponseMessage from '../../formResponseMessage';
import {FormGroup} from 'arag-ui-lib';
  

const PercentageStep4 = (props) => {
    if (props.currentStep !== 4)
        return null;
    
    const onChangeStoreSettings = (event) => {
        const { name, value } = event.target;
    
        // Default value and sanitize
        const sanitizedInput = (value || '').replace(/[^0-9.]/g, '');
        const sanitizedValue = sanitizedInput ? Math.max(Number(sanitizedInput), 0) : 0;
    
        props.changeStoreSettings(name, sanitizedValue);
    };
    

    return (
        <div>
            <p className='premiumSettingsWizard-step-message'>{props.stepMessage}</p>
                <FormGroup
                    labelSize='col-sm-3'
                    inputSize='col-sm-7'
                    formGroupTestId='percentage-premium-settings-step-4-recoverable-rate'
                    label='Recoverable Rate'
                    variant='currency'
                    inputProps={{
                    required: true,
                    onChange: onChangeStoreSettings,     
                    value: props.recoverableRatePercentage, 
                    name: 'recoverableRatePercentage',
                    disabledDropdown: true,
                    handleOptionSelect: () => {},
                    menuOptions: [{ sign: '%', code: '%' }],
                    selectedCurrency: { sign: `%`, code: '%' },
}}
                    
                />
            <PercentageWizardTable
                isEditMode={props.isEditMode}
                handlePercentagePremiumTableChange={props.handlePercentagePremiumTableChange}
                selectedCaseType={props.selectedCaseType}
                selectedSubCaseType={props.selectedSubCaseType}
                getSolicitor={props.getSolicitor}
                tableData={props.tableData}
                getAgentIndex={props.getAgentIndex}
                getTableIndex={props.getTableIndex}
                handlePremiumAndUnderwriterChange={props.handlePremiumAndUnderwriterChange}
                damageBands={props.damageBands}
                selectedCaseStages={props.selectedCaseStages}
                solicitorsList={props.solicitorsList}
                getTableHeaderData={props.getTableHeaderData}
            />
            {
                props.validationMessage !== '' ?
                    <FormResponseMessage
                        LeftWrapper=''
                        CenterWrapper='col-sm-12'
                        MessageStyle='formResponseMessage-reject'
                        Message={props.validationMessage}
                    />
                    :
                    null
            }
        </div>
    )
};

export default PercentageStep4;